import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class WorkOrderStatusService {
  getAll(organizationId: string, propertyId: string) {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(
      `${apiURL}/${organizationId}/${propertyId}/workOrderStatuses`,
      options,
    );
  }
}

export default WorkOrderStatusService;
